import axios from 'axios'
import CommonUtils from "./CommonUtils";

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {
    getBuses(payload) {
        const url = `${base_url}/bus/lines/all`;

        return axios.post(url, payload)
    },

    addBusCompany(payload){
        const url = `${base_url}/bus`;

        return axios.post(url, payload)
    },

    addBusLineCalendar(payload){
        const url = `${base_url}/bus/lines/calendars`;

        return axios.post(url, payload)
    },

    AddBusStation(payload){
        const url = `${base_url}/bus/stations`;

        return axios.post(url, payload)

    },
    addBusLine(payload){

        const url = `${base_url}/bus/lines`;
        return  fetch(url,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Origin: "http://admin.notaxi.info",
                'Authorization': 'Bearer ' + CommonUtils.getCookie('token')
            },
            body: JSON.stringify(
                payload
            )
        });

        // return axios.post(url, payload)

    }
}
